import { isEngagementEngine } from './advisoryEngine';
import type { ReviewRequest, ReviewSnapshot } from './advisoryReview';

export type ReviewPrepareRequest = Extract<ReviewRequest, { operation: 'prepare' }>;
const key = (scope: string) => `advisory-intake:${scope}`;

/** Only replay the allowlisted preparation payload for this signed-in user and engagement. */
export function readPendingIntake(scope: string): ReviewPrepareRequest | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key(scope)) ?? 'null');
    if (
      !value ||
      value.operation !== 'prepare' ||
      value.workspaceVersion !== 1 ||
      typeof value.requestId !== 'string' ||
      !value.requestId.trim() ||
      typeof value.userQuery !== 'string' ||
      !value.userQuery.trim() ||
      (value.engine !== undefined && !isEngagementEngine(value.engine))
    )
      return null;
    return {
      operation: 'prepare',
      requestId: value.requestId,
      userQuery: value.userQuery,
      workspaceVersion: 1,
      ...(value.engine === undefined ? {} : { engine: value.engine }),
    };
  } catch {
    return null;
  }
}

/** A storage failure must keep navigation state intact and prevent submission. */
export function savePendingIntake(scope: string, request: ReviewPrepareRequest): void {
  sessionStorage.setItem(key(scope), JSON.stringify(request));
}

export function acknowledgePendingIntake(scope: string, snapshot: ReviewSnapshot): void {
  const pending = readPendingIntake(scope);
  if (
    !pending ||
    pending.userQuery !== snapshot.originalQuery ||
    (pending.engine !== undefined && pending.engine !== snapshot.engine)
  )
    return;
  try {
    sessionStorage.removeItem(key(scope));
  } catch {
    // The server has saved the choice. A leftover receipt is safe to replay.
  }
}
